var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobalTech2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "o723upb2ka",
    width: "158.6%",
    height: "158.6%",
    x: "-29.3%",
    y: "-29.3%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "dcshpdn9zb",
    cx: 25.6,
    cy: 25.6,
    r: 25.6
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-419 -105) translate(429 115)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#o723upb2ka)",
    xlinkHref: "#dcshpdn9zb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#dcshpdn9zb"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 23.5,
    r: 2.5,
    fill: "#041F41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 23.5,
    r: 2.5,
    fill: "#041F41"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    x: 7,
    y: 6,
    stroke: "#041F41",
    strokeWidth: 2,
    rx: 19
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#041F41",
    strokeLinecap: "square",
    d: "M12.449 16.033c1.667-.644 3.333-.966 5-.966 1.667 0 3.333.322 5 .966h0",
    transform: "rotate(-15 17.449 15.55)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#041F41",
    strokeLinecap: "square",
    d: "M14.449 34.033c2.167-.644 4.333-.966 6.5-.966s4.333.322 6.5.966h0",
    transform: "rotate(10 20.949 33.55)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#041F41",
    strokeLinecap: "square",
    d: "M12.449 23.033c1.667-.644 3.333-.966 5-.966 1.516 0 3.031.266 4.547.8 0 0 0 0 0 0 .045.015.069.064.053.109-.012.034-.045.057-.081.057",
    transform: "rotate(-15 17.449 22.55)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#041F41",
    strokeLinecap: "square",
    d: "M25.449 23.033c1.667-.644 3.333-.966 5-.966 1.575 0 3.15.287 4.725.863 0 0 0 0 0 0 .027.01.041.04.031.068-.007.021-.027.035-.05.035",
    transform: "rotate(-15 30.449 22.55)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#041F41",
    strokeLinecap: "square",
    d: "M29.449 16.033c1.667-.644 3.333-.966 5-.966 1.667 0 3.333.322 5 .966h0",
    transform: "scale(-1 1) rotate(-15 0 277.215)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalTech2);
export default __webpack_public_path__ + "static/media/globalTech2.0da40d72cc4dff97ecd8f7ef96d2ff74.svg";
export { ForwardRef as ReactComponent };